export enum ProjectFeatureType {
  Home = "home",
  Shop = "shop",
  Not_Featured = "not-featured",
}
